import React, { useEffect, useState } from 'react';
import configData from "../config/config.json";
import { Form } from '@progress/kendo-react-form';
import { Field } from '@progress/kendo-react-form';
import { FormReviewLabel } from '../core/customComponents';
import { tovalidateExpdate } from '../core/validationRules';
import FormContainer from './FormContainer';
import { Button } from '@progress/kendo-react-buttons';
import { Checkbox } from "@progress/kendo-react-inputs";
import helper from '../data/Helper';
import Loading from './Loading';

import { useHistory } from "react-router-dom";

import { v4 as uuidv4 } from 'uuid';
import useCountDown from "react-countdown-hook";
import {
    Notification,
    NotificationGroup,
} from "@progress/kendo-react-notification";
import toFetchIDValue from '../data/IdTypeCheck';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';

var CryptoJS = require("crypto-js");
let key = CryptoJS.enc.Utf8.parse("8080808080808080");
let iv = CryptoJS.enc.Utf8.parse("8080808080808080");

configData.RefferenceNo = localStorage.getItem('Ref');
let LBL_TNC = configData.TERMS_CONDITIONS;
let LBL_SUBMITTED_TEXT = configData.LBL_SUBMITTED_TEXT;
let hideContentForSubmit = false;//TODO to change false
let responsesetitesms = 1;
let cmpnt = FormReviewLabel;

let url = configData.URL_TERMS;
let url1 = configData.URL_TERMS1;
let urlGarmin = configData.URL_GarminWatch;
let urlIngersoll = configData.URL_Ingersoll;

let TF1FRM1;
let CCCANO1;
let Pricing1;
let Trnsferto1;
let NameacntHolder1;
let CCAnCNTNO1;
let AMNT1;
let SourceCodehandle;


const ReviewDetails = (props) => {
    let history = useHistory();
    // TODO
    const [response, setResponce] = useState(null);

    const [OTPValue, setOTPValue] = useState("");
    const [OtpconfirmDisabled, setOtpconfirmDisabled] = useState(false);
    const [toshowResend, settoshowResend] = useState(false);
    const [isLoading, setIsLoading] = useState(false); //to show api call
    const [checkedTerms, setcheckedTerms] = useState(false); //to show api call
    const [disabltoRequestotp, setdisabltoRequestotp] = useState(true); //to show api call
    const [ALLOTPgenration, setALLOTPgenration] = useState("");
    const [showCloseActionManu, setshowCloseActionManu] = useState(false);


    const [count3TimeToExist, setcount3TimeToExist] = useState(0);
    const initialTime = 120 * 1000; // initial time in milliseconds, defaults to 60000
    const interval = 1000; // interval to change remaining time amount, defaults to 1000
    const [timeLeft, { start, pause, resume, reset }] = useCountDown(
        initialTime,
        interval
    );

    const [currentDateTime, setcurrentDateTime] = useState(); //to show api call
    const [trimMobile, settrimMobile] = useState("");

    let resMobile;
    let resCountrycode;

    const [tohideNotification, settohideNotification] = useState(false);
    const [OtpMobilenumberGen, setOtpMobilenumberGen] = useState('');

    const [emailValue, setemailValue] = useState('');
    const [cifNum, setcifNum] = useState('');
    const [fullnameValue, setfullnameValue] = useState('');


    const [SavedInformation, setSavedInformation] = useState({
        emailAddress: "",
        idNum: "",
        idType: "",
        idIssueCountry: "",
        emailAddress: "",
        customerName: "",
        by_prdType: "",
        uniqueRequestId: ""
    });


    useEffect(() => {

        setIsLoading(true);

        if (tovalidateExpdate(new Date().getMinutes())) {
            if (configData.RefferenceNo) {
                const requestBody = {
                    //new changes passing details to save at verification
                    referenceno: configData.RefferenceNo,
                    num: localStorage.getItem('nricval')
                }

                const requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Access-Control-Allow-Headers': 'Content-Type',
                        'Cache-Control': 'no-cache',//for IE issues
                        'Pragma': 'no-cache',
                        'Authorization': "Maybank" + " " + localStorage.getItem('tkn')

                    },
                    body: JSON.stringify(requestBody)
                };

                let baseUrl = configData.GET_FTDATA_PROD;

                if (configData.SERVER_STATUS === 'SIT') {
                    baseUrl = configData.GET_FTDATA_SIT;
                }
                else if (configData.SERVER_STATUS === 'UAT') {
                    baseUrl = configData.GET_FTDATA;
                }
                else {
                    baseUrl = configData.GET_FTDATA_PROD;
                }

                fetch(baseUrl, requestOptions)

                    .then(async response => {

                        setIsLoading(false);
                        const data = await response.json();
                        if (!data.didError) {
                            if (data.model.fields) {
                                setResponce(data);
                                configData.NEWReffID = data.refNo;
                                setSavedInformation(data.model);
                                window.scrollTo(0, 0);
                            }

                        } else {

                        }
                    })
                    .catch(err => {
                        // console.log(err)
                        setIsLoading(false);
                        alert("This session has timed out for your security.Please try again")
                        helper.toHomeScreen();
                    })
            }
            else {
                setIsLoading(false);
                alert("This session has timed out for your security.Please try again")
                helper.toHomeScreen();
            }
        }
        else {
            setIsLoading(false);
            alert("This session has timed out for your security.");
            helper.toHomeScreen();
        }
    }
        , [])

    if (!response) {
        return false;
    } else {
        responsesetitesms = response.model.fields.Fields.count;
        if (response.model.fields.Fields.FT1) {

            let res = response.model.fields.Fields.FT1;
            let assaginvalueCCANo1;
            if (res.CreditAcntNO) {
                assaginvalueCCANo1 = res.CreditAcntNO;
                configData.setAcntTypename = configData.LBL_RVWLBL_CCANO;
            } else if (res.CreditAbleAcntNO) {
                assaginvalueCCANo1 = res.CreditAbleAcntNO;
                configData.setAcntTypename = configData.LBL_RVWLBL_CAANO;
            }

            if (res.CreditCardnumber) {
                try {
                    configData.decryptCA = CryptoJS.AES.decrypt(res.CreditCardnumber, key, { iv: iv });
                    configData.decryptCA = configData.decryptCA.toString(CryptoJS.enc.Utf8);
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                configData.decryptCA = res.CreditCardnumber;
            }


            if (configData.setAcntTypename) {
                try {
                    configData.decryptCA11 = CryptoJS.AES.decrypt(assaginvalueCCANo1, key, { iv: iv });
                    configData.decryptCA11 = configData.decryptCA11.toString(CryptoJS.enc.Utf8);
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                configData.decryptCA11 = assaginvalueCCANo1;
            }

            TF1FRM1 = res.transferFrom;
            CCCANO1 = configData.decryptCA11;
            Pricing1 = res.pricing;
            Trnsferto1 = res.transferto;
            NameacntHolder1 = res.Nameancnt;
            CCAnCNTNO1 = configData.decryptCA;
            AMNT1 = res.Amount;
            SourceCodehandle = res.SOURCE_CODE;

        }
    }


    const toHHMMSS = (val) => {

        var sec_num = parseInt(val / 1000, 10); // don't forget the second param
        var hours = Math.floor(sec_num / 3600);
        var minutes = Math.floor((sec_num - hours * 3600) / 60);
        var seconds = sec_num - hours * 3600 - minutes * 60;

        if (hours < 10) {
            hours = "0" + hours;
        }
        if (minutes < 10) {
            minutes = "0" + minutes;
        }
        if (seconds < 10) {
            seconds = "0" + seconds;
        }
        return minutes + ":" + seconds;
    };

    const updateInputValue = async (e) => {
        const re = /^[0-9\b]+$/;
        if (e.target.value === "" || re.test(e.target.value)) {
            await setOTPValue(e.target.value);
        }

        if (OTPValue.length === 5) {
            await setOtpconfirmDisabled(true);
        } else {
            await setOtpconfirmDisabled(false);
        }
    };

    const isNumber = async (evt) => {
        evt = evt ? evt : window.event;
        var charCode = evt.which ? evt.which : evt.keyCode;

        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            await setOTPValue("");
            await setOtpconfirmDisabled(false);
            return false;
        } else {
            await setOtpconfirmDisabled(true);
            return true;
        }
    };

    const validateForm = () => {
        let isValid = true;
        const resObj = response.model.fields.Fields.FT1;

        if (resObj.SOURCE_CODE === null || resObj.SOURCE_CODE === '' || resObj.SOURCE_CODE.length === 0) {
            isValid = false;
        }
        else if (resObj.SCHEME_CODE === 'NA' && resObj.PROMO_CODE === 'NA') {
            isValid = false;
        }

        return isValid;
    }

    const handleSubmit1 = () => {
        //OTP GENERATION START

        const responseOBJ = {};

        if (validateForm() === false) {
            alert('Some thing went wrong! please try again');
            helper.toHomeScreen();
            return;
        }

        let requestBody = {
            idNum: SavedInformation.nric,//localStorage.getItem('Otp_nric'),
            idType: SavedInformation.idType,//localStorage.getItem('Otp_idtype'),
            idIssueCountryCode: SavedInformation.idIssueCountry,//localStorage.getItem('Otp_countCode'),
            email: SavedInformation.emailAddress,//localStorage.getItem('Otp_email'),
            name: SavedInformation.customerName,//localStorage.getItem('Otp_Name'),
            by_prdType: localStorage.getItem('Otp_Prod_type'),
            uniqueRequestId: uuidv4(),//localStorage.getItem('Otp_StateIDvalue')// uuidv4()
        }

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Cache-Control': 'no-cache',//for IE issues
                'Pragma': 'no-cache',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        };

        if (!requestBody.email) {
            requestBody.email = "";
        }


        const url = getSendOTPURL();

        fetch(url + requestBody.idNum + '/' + requestBody.idType + '/' + requestBody.idIssueCountryCode + '/' + uuidv4() + "?email=" + requestBody.email + "&name=" + requestBody.name + "&by_prodType=" + requestBody.by_prdType, requestOptions)
            .then(async response => {
                const data = await response.json();
                if (!data.didError) {
                    setIsLoading(false);
                    let res = data.model.msg;
                    let resMsgBdy = res.msgBody;
                    let resMsgHdr = res.msgHdr;
                    setALLOTPgenration(res.msgBody);

                    if (resMsgHdr.statusCode === "0") {
                        setdisabltoRequestotp(true);
                        settohideNotification(true);
                        settoshowResend(true);
                        start();
                        setIsLoading(false);
                        responseOBJ.refNo = data.refNo;

                        if (resMsgBdy.mobileNum) {
                            configData.decryptMbl = CryptoJS.AES.decrypt(resMsgBdy.mobileNum, key, { iv: iv })
                            configData.decryptMbl = configData.decryptMbl.toString(CryptoJS.enc.Utf8)

                            setOtpMobilenumberGen(configData.decryptMbl);
                            let mobiltrim = (configData.decryptMbl).substring(6);
                            settrimMobile(mobiltrim)
                        } else {
                            configData.decryptMbl = resMsgBdy.mobileNum;
                            setOtpMobilenumberGen(configData.decryptMbl);
                            settrimMobile(configData.decryptMbl);
                        }
                    } else {
                        settoshowResend(false);
                        setIsLoading(false);
                        localStorage.clear();
                        history.push("error");
                        localStorage.clear();
                    }
                } else {
                    setIsLoading(false);
                    localStorage.clear();
                    setdisabltoRequestotp(false);
                    history.push("error");
                }
            })
            .catch(error => {
                setIsLoading(false);
                // this.setState({ errorMessage: error });
                if (configData.RESEND <= 1) {
                    //alert(error);
                }
                setdisabltoRequestotp(false);
                console.error('There was an error!', error);
            });
    }

    const verifyOTPDetails = async () => {


        if (OTPValue) {
            if (!emailValue) {
                setemailValue('');
            }

            const requestBody = {
                idNum: SavedInformation.nric,
                idType: toFetchIDValue("IDTYPE", SavedInformation.idType,),
                idIssueCountryCode: toFetchIDValue("countries", SavedInformation.idIssueCountry),
                email: SavedInformation.emailAddress,
                name: SavedInformation.customerName,
                by_prdType: configData.PRODUCT_TYPE,
                cifNum: ALLOTPgenration.cifNum,
                otp: OTPValue,
                mobileNum: "0",
                accessID: "00000000",
                uniqueRequestid: uuidv4(),
                appId: '0'
            }

            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Access-Control-Allow-Headers': 'Content-Type',
                    'Cache-Control': 'no-cache',//for IE issues
                    'Pragma': 'no-cache',
                },
                body: JSON.stringify(requestBody)

            };

            const url = getVerifyOTPURL();

            fetch(url, requestOptions)

                .then(async response => {

                    const data = await response.json();
                    if (!data.didError) {
                        let res = data.model.msg;
                        let resMsgBdy = res.msgBody;
                        let resMsgHdr = res.msgHdr;

                        if (data.token) {
                            let tokenid = data.token;
                            let expirytoken = data.tokenExpirationDate;

                            if (resMsgBdy) {
                                localStorage.setItem("nricval", resMsgBdy.nric);
                            }
                            if (resMsgHdr.statusCode === "0") {

                                let datestr = new Date();
                                localStorage.setItem("ddt", datestr);
                                setcurrentDateTime(localStorage.getItem('ddt'));
                                settohideNotification(false);
                                SubmitFormdetails();
                            }
                            else {
                                if (resMsgHdr.statusDesc)
                                    setcount3TimeToExist(count3TimeToExist + 1)
                                if (count3TimeToExist <= 1) {
                                    alert("The OTP entered has expired/is invalid. Please re-enter the 6 Digit OTP.")
                                } else if (count3TimeToExist === 2) {
                                    alert("You have exceeded the max OTP to confirm, please try after some time");
                                    helper.toHomeScreen();
                                    return;
                                } else {
                                    alert("You have exceeded the max OTP to confirm, please try after some time");
                                    helper.toHomeScreen();
                                    return;
                                }
                            }
                        } else {
                            history.push("error");
                            localStorage.clear();
                        }
                    } else {
                        history.push("error");
                        localStorage.clear();
                    }
                })
                .catch(error => {
                    console.error('There was an error!', error);
                });

        } else {
            await setOtpconfirmDisabled(true);
            alert("Please enter valid numeric 6 digit OTP");
        }

    }


    const SubmitFormdetails = async () => {

        //TODO OTPCHANGES
        hideContentForSubmit = true
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Access-Control-Allow-Headers': 'Content-Type',
                'Cache-Control': 'no-cache',//for IE issues
                'Pragma': 'no-cache',
                'Authorization': "Maybank" + " " + localStorage.getItem('tkn')
            }
        };

        const url = getSubmitURL();
        fetch(url + "?refno=" + configData.RefferenceNo + "&submit=true", requestOptions)
            .then(async response => {
                const data = await response.json();
                if (data.status === "Submitted") {
                    hideContentForSubmit = true;
                    window.scrollTo(0, 0);
                    localStorage.clear();
                } else {
                    hideContentForSubmit = false;
                    alert("error");
                }
            })
            .catch(error => {
                hideContentForSubmit = false;
                console.error('There was an error!', error);
            });
    }

    const restart = () => {

        const newTime = 10 * 1000;
        start(newTime);
        setOTPValue("");
        settoshowResend(false);
        handleResendSubmit();
    }

    const handleResendSubmit = () => {
        handleSubmit1();
    };


    const termscheckoption = () => {
        setcheckedTerms(!checkedTerms);//TODO Srijith !
        setdisabltoRequestotp(!disabltoRequestotp)
    }

    const toBackFTDetails = () => {
        history.push('Details');
    }

    const toMaybankHome = () => {
        document.location.href = configData.URL_NAV_MAYBANK;
    }

    const getVerifyOTPURL = () => {
        let baseUrl = configData.URL_VERIFY_OTP_PROD;
        if (configData.SERVER_STATUS === 'SIT') {
            baseUrl = configData.URL_VERIFY_OTP_SIT;
        }
        else if (configData.SERVER_STATUS === 'UAT') {
            baseUrl = configData.URL_VERIFY_OTP;
        }
        else {
            baseUrl = configData.URL_VERIFY_OTP_PROD;
        }
        return baseUrl;
    }

    const getSendOTPURL = () => {
        let baseUrl = configData.URL_SEND_OTP_PROD;
        if (configData.SERVER_STATUS === 'SIT') {
            baseUrl = configData.URL_SEND_OTP_SIT;
        }
        else if (configData.SERVER_STATUS === 'UAT') {
            baseUrl = configData.URL_SEND_OTP;
        }
        else {
            baseUrl = configData.URL_SEND_OTP_PROD;
        }
        return baseUrl;
    }


    const ManuCardVisaCA = () => {
        setshowCloseActionManu(!showCloseActionManu);
    }
    const toCloseDialogManu = () => {
        setshowCloseActionManu(!showCloseActionManu);
    }

    const getSubmitURL = () => {

        let baseUrl = configData.URL_SUBMIT_PROD;

        if (configData.SERVER_STATUS === 'SIT') {
            baseUrl = configData.URL_SUBMIT_SIT;
        }
        else if (configData.SERVER_STATUS === 'UAT') {
            baseUrl = configData.URL_SUBMIT;
        }
        else {
            baseUrl = configData.URL_SUBMIT_PROD;
        }
        return baseUrl;
    }
    const listStyle = {
        listStyleType: 'disc'
    };
    const listStyledeci = {
        listStyleType: 'decimal'
    };


    return (
        <div className="container-fluid">
            {isLoading && <Loading />}
            <div className='row '>
                <div className="container mt-5">
                    <h2 className="welcome mb-0">{configData.APP_NAME}</h2>
                </div>
                <FormContainer>
                    <Form
                        // onSubmit={handleSubmit1}
                        render={(formRenderProps) => (
                            <form onSubmit={formRenderProps.onSubmit} className={'k-form'}>
                                <fieldset>
                                    <br></br>
                                    <div className="row around-xs inputPairelementVisible"  >
                                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                            {!hideContentForSubmit && <legend>{configData.HDR_RVW_DETAILS}</legend>}
                                            {hideContentForSubmit && <legend>{configData.HDR_RVW_APPLICATION}</legend>}
                                        </div>
                                    </div>
                                    <hr className="panelLine"></hr>
                                </fieldset>

                                <fieldset>

                                    {!hideContentForSubmit && <div className="row around-xs inputPair elementVisible"  >
                                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{
                                            backgroundColor: "black", color: "white", padding: "20px", borderTopLeftRadius: "10px",
                                            borderTopRightRadius: "10px"
                                        }}>

                                            <strong className="text-left">{configData.LBL_FT_REQUEST}</strong>
                                            <strong className="text-right" style={{ float: 'right' }} onClick={toBackFTDetails}><span style={{ cursor: "pointer" }} className="k-icon k-i-pencil"></span></strong>


                                        </div>
                                    </div>}
                                    {hideContentForSubmit && <div className="row around-xs inputPair elementVisible"  >
                                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{
                                            backgroundColor: "#389a6e", color: "white", padding: "20px", borderTopLeftRadius: "10px",
                                            borderTopRightRadius: "10px"
                                        }}>

                                            <strong className="box text-left"><span className="k-icon k-i-check"></span><span style={{ padding: "8px" }}>Success!</span></strong>
                                        </div>

                                    </div>}

                                </fieldset>
                                {responsesetitesms >= 1 && <fieldset>

                                    {/* <Field id={"Transfer From"} label={TF1FRM1} component={cmpnt} />
                                    <Field id={configData.setAcntTypename} label={CCCANO1} component={cmpnt} />
                                    <Field id={"Pricing"} label={Pricing1} component={cmpnt} />
                                    <Field id={"Transfer To"} label={Trnsferto1} component={cmpnt} /> */}
                                    <Field id={"Name on Debit Card"} label={NameacntHolder1} component={cmpnt} />
                                    <Field id={"Maybank Savings or Current Account Number"} label={CCAnCNTNO1} component={cmpnt} />
                                    {/* <Field id={"Amount"} label={AMNT1} component={cmpnt} /> */}

                                    {/* {!hideContentForSubmit && <p>Important Notes</p>
                                    }

                                    {!hideContentForSubmit && <hr className="panelLine"></hr>
                                    } */}
                                    {/* 
                                    {!hideContentForSubmit && <ul style={listStyle}> <li>Your new Debit Card will be linked to your Maybank CreditAble Account.</li> <li> Any charge inclusive of point-of-sale transactions, ATM withdrawals and online funds transfers will be deducted from your Maybank CreditAble Account.</li> <li> Credit balances in your Maybank CreditAble Account will be drawn down first before your credit line is utilised.</li>  </ul>
                                    } */}

                                </fieldset>}

                                <br></br><br></br>
                                <fieldset>


                                    {hideContentForSubmit && <hr className="panelLine"></hr>}

                                    {hideContentForSubmit &&

                                        <Field id={"Reference Number"} label={configData.NEWReffID} component={cmpnt} />

                                    }
                                    {hideContentForSubmit &&

                                        <Field id={"Date"} label={currentDateTime} component={cmpnt} />


                                    }
                                </fieldset>



                                {!hideContentForSubmit && <>
                                    {SourceCodehandle === configData.SRC_CODE_HNW ? (
                                        //  {!hideContentForSubmit &&
                                        <div>
                                            <Checkbox
                                                checked={checkedTerms}
                                                id={"declYesBOA"}
                                                disabled={checkedTerms}
                                                label={<div style={{
                                                    marginTop: "-18px",
                                                    marginLeft: "25px"
                                                }}>


                                                    <span>I have read, understood and agreed to be bound by </span>
                                                    <a href={urlIngersoll} target="_blank">Terms and Conditions for Maybank Funds Transfer Ingersoll Timepiece Promotion</a>
                                                    <span>  and other  </span>
                                                    <a href={url1} target="_blank">Terms and Conditions</a>
                                                    <span>  on Fees and Charges.</span>




                                                </div>}
                                                onChange={termscheckoption}
                                            />
                                            {/* <span>I have read , understood and agreed to be bound by </span>
                                                    <a href={urlGarmin} target="_blank">Terms and Conditions</a>
                                                    <span> for Maybank Funds Transfer Garmin Vivomove Timepiece Promotion and Other  </span>
                                                    <a href={url1} target="_blank">Terms and Conditions</a>
                                                    <span>  on Fees and Charges.</span> */}

                                            {
                                                checkedTerms === false &&
                                                <span style={{ color: "red", marginLeft: "22px" }}>{"Please accept terms & conditions of the application to proceed"}</span>
                                            }
                                        </div>
                                        // }

                                    ) : <div>
                                        <>Declaration</>
                                        <hr className="panelLine"></hr>
                                        
                                        <br></br>
                                        <div style={{textAlign: "justify"}}>
                                            <b><u>Fair Dealing</u></b> 
                                            <br></br><br></br>
                                            The Guidelines on Fair Dealing issued by the Monetary Authority of Singapore aim to promote fair dealing by financial institutions when they conduct business with their customers. At Maybank, we are fully committed to ensuring fair dealing outcomes for our customers. In providing products and services to our customers, there may be situations where we may have to exercise our right to unilaterally revise certain terms and conditions of such products or services. For more information, please refer to the Fair Dealing Disclosure Notice at maybank.sg/fairdealing.
                                        </div>

                                        <p></p>
                                                                        
                                        <Checkbox
                                            // checked={checkedTerms}
                                            id={"declYesBOA"}
                                            //  disabled={checkedTerms}
                                            label={<div style={{
                                                marginTop: "-18px",
                                                marginLeft: "25px"
                                            }}>

                                                <span>By submitting this application, I hereby confirm I have read, understood and agree to the Terms and Conditions governing <h4 onClick={ManuCardVisaCA}> Maybank Manchester United Platinum Visa Debit Card</h4></span>
                                                {/* <a href={url} target="_blank"> Maybank Platinum Debit Card</a>
                                                and<a href={url1} target="_blank"> Maybank CreditAble.</a> */}
                                                {/* <span>  on Fees and Charges.</span> */}





                                                {showCloseActionManu && <Dialog onClose={toCloseDialogManu} title={"Maybank Manchester United Platinum Visa Debit Card "} >

                                                    <h4> {"By signing below:"}</h4>
                                                    <div style={{ height: '400px', width: '600px', overflowY: 'auto' }}> (1) I understand that I am applying for a Maybank Manchester United Platinum Visa Debit Card (“Card”);<br></br>
                                                        (2) I agree that my application herein is subject to Maybank’s approval and Maybank has the absolute discretion to decline my application without giving any reason and to retain documents submitted as property of Maybank;<br></br>
                                                        (3) I agree that Maybank may send the Card to me by ordinary mail or such other means at my sole risk to my mailing address last registered in Maybank’s records or to the mailing address as updated and specified herein:<br></br>
                                                        (4) I understand and agree that the use of the Card is subject to:<br></br>
                                                        (a) the terms and conditions governing the Card;<br></br>
                                                        (b) the terms and conditions governing the respective accounts linked to the Card;<br></br>
                                                        (c) all other terms and conditions governing the respective services linked to the Card, including any amendments and revisions in relation to any of the above terms and conditions;<br></br>
                                                        (5) I represent and warrant that all information provided by me in this application is true and complete and undertake to notify Maybank immediately of any change in such information;<br></br>
                                                        (6) I confirm that at the time of this application, I am not an undischarged bankrupt and no statutory demand has been served on me nor any legal proceedings commenced against me;<br></br>
                                                        (7) I agree to the purposes set out in the Bank’s Data Protection Policy (the link to which is provided below) for the collection, use and disclosure of my/our personal data, including authorising the Bank to disclose or release, any information whatsoever relating to me/any one of us to:<br></br>
                                                        (a) any credit bureau or any other organisation or corporation set up for the purpose of collecting and providing information relating to the credit standing of persons;<br></br>
                                                        (b) any person who has or may enter into contractual relations with Maybank in relation to the Card (including, without limitation, any co-brand partner); and <br></br>
                                                        (c) any other person(s) for the purpose of processing this application.<br></br>
                                                        (8) I agree that my information may be used for the purpose of promoting any services or products whether conducted by Maybank, any of Maybank’s co-brand partners or such other parties who Maybank may disclose my information to. I agree to receive information relating to such promotions from time to time.<br></br>
                                                        (9) By providing the information in this application form (and any other information that I may provide to you from time to time in connection with Maybank products and services). I agree and consent to Maybank Singapore Limited and its holding companies (collectively, “Maybank”) collecting, using, disclosing and sharing amongst themselves my/our personal data, and disclosing such personal data to Maybank’s authorised service providers and relevant third parties for purposes reasonably required by Maybank to process my/our application(s), provide me/us with the products or services which I am applying for, as well as the purposes set out in Maybank Singapore branch’s Data Protection Policy, which is accessible at www.maybank2u.com.sg or which may be provided to me/us upon request. I confirm I have read and understood the Data Protection Policy. If I should withdraw my/our consent to the processing or handling of my personal data in respect of any purpose which Maybank may reasonably consider to be essential in order for Maybank to provide me with the products and/or services applied for, Maybank shall be entitled to treat my Maybank Debit Card Account as having been terminated by me/us without prejudice to any rights and remedies which it may have at law against me/us.<br></br>
                                                        I acknowledge and agree that:<br></br>
                                                        (a) each of Maybank and Manchester United Group (“Co-Brand Partner”) will be separately collecting, using and disclosing my/our personal data, and that I have read and agree to the terms of the Co-Brand Partner’s data protection policy set out below;<br></br>
                                                        (b) Maybank’s data protection policy is separate from the Co-Brand Partner’s data protection policy and that each of Maybank and Co-Brand Partner shall only be responsible for its own collection use or disclosure of my/our personal data, and shall not be liable for the other party’s handling or use thereof. I agree to directly address any queries, access or correction requests, or complaints in relation to the handling of my personal data to the relevant party;<br></br>
                                                        (c) each of Maybank and the Co-Brand Partner, as well as their respective agents and authorised service providers are permitted to collect, use, disclose and share my/our personal data between themselves for purposes reasonably required by Maybank and/or the Co-Brand Partner to process my application herein and provide me with the products and services related to the card as well as administer any privileges and benefits associated therewith (for example, discount privileges and loyalty bonuses, if applicable to the card). This may include sharing account and transaction related information.<br></br>
                                                        <h4> Manchester United Privacy Notice for Applicants to the Manchester United Co-Brand Card Only</h4>
                                                        If you have applied for the Manchester United Card, by submitting this form, you expressly consent to Manchester United ('MU') Group (being all companies with the MU name) and the other MU Commercial Partners (as both may change over time) collecting, using and disclosing your personal data (a) to provide you with the products and services which you have requested, (b) for consumer profiling and market research in relation to benefits and privileges, products and services related to and/or associated with the MU Card and (c) to contact you by post, phone or electronically (including via email, text, fax and other electronic means of communication) about benefits, privileges, products, services, offers and events related to and/or associated with the MU Co-Brand Card. If you would prefer not to receive any promotional and marketing communications with regards to the MU Card, please email marketingoptout@manutd.co.uk within 14 days, ensuring that you use the email address that has been provided in your application form. Please read the MU Privacy Policy which includes an updated list of MU Group companies and MU Commercial Partners at www.manutd.com or for a copy, write to the MU DP Officer at MU Ltd, Freepost, NWW4517A, Old Trafford, Manchester M161BX.



                                                    </div>
                                                    <DialogActionsBar>
                                                        <button className="k-button k-primary" onClick={toCloseDialogManu}>OK</button>

                                                    </DialogActionsBar>
                                                </Dialog>}
                                            </div>}
                                            onChange={termscheckoption}
                                        />

                                        {/* {
                                            checkedTerms === false &&
                                            <span style={{ color: "red", marginLeft: "22px" }}>{"Please accept terms & conditions of the application to proceed"}</span>
                                        } */}
                                    </div>

                                    }
                                </>}
                                

                                <br></br><br></br>
                                {hideContentForSubmit && <b>{LBL_SUBMITTED_TEXT}</b>}
                                <br></br><br></br>
                                {!hideContentForSubmit && <div className="text-right">


                                    <Button className="btn btn-success btnMaybank" type={'submit'} style={{ padding: "13px" }}
                                        primary={true}
                                        disabled={disabltoRequestotp} onClick={handleSubmit1}>{"CONFIRM/ REQUEST OTP"} </Button>

                                </div>
                                }
                                <br></br>
                                {hideContentForSubmit && <div className="text-center">
                                    <button className="btnMaybank" type={'submit'} onClick={toMaybankHome}><span>{configData.ON_DONE}</span></button>

                                </div>}
                                <br></br><br></br>
                            </form>

                        )} />




                    {tohideNotification ? (
                        <NotificationGroup
                            style={{
                                right: 0,
                                bottom: 0,
                                alignItems: "flex-start",
                                flexWrap: "wrap-reverse",
                            }}>

                            <Notification
                                type={{ style: "warning", icon: false }}
                                closable={false} >

                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-1 col-md-1 col-lg-1">
                                        <div className="box"></div>
                                    </div>
                                    <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                                        <div
                                            className="box row"
                                            style={{
                                                textAlign: "left",
                                                color: "black",
                                                marginLeft: "10px",
                                            }} >
                                            <p> &nbsp; OTP will be sent to XXXX {trimMobile}</p>{" "}
                                            <p> &nbsp; Please confirm received OTP within 2 minutes. </p>
                                        </div>
                                    </div>

                                    <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                                        <div
                                            className="box row"
                                            style={{
                                                textAlign: "left",
                                                color: "black",
                                                margin: "10px",
                                            }} >

                                            <div className="text-center" style={{ marginTop: "0.6rem" }} >
                                                <p data-tip="If you did not receive any, you can requestanother SMS OTP in 2:00"
                                                    className="" />
                                                {timeLeft === 0 && toshowResend ? (
                                                    <Button
                                                        className="btn btn-success btnMaybank"
                                                        style={{ padding: "10px", marginTop: "-4px" }}
                                                        primary={true}
                                                        onClick={restart}>
                                                        RESEND OTP
                                                    </Button>
                                                ) : (
                                                    <div></div>
                                                )}


                                                {toshowResend ? (
                                                    <div>
                                                        {" "}
                                                        Resend in {toHHMMSS(timeLeft)}{" "}
                                                        <span
                                                            className="k-icon k-i-clock"
                                                            style={{ marginTop: "-2px" }}
                                                        ></span>
                                                    </div>
                                                ) : (
                                                    <div></div>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                                        <div className="box">
                                            <div
                                                className="text-center"
                                                style={{ marginTop: "1.2rem" }}
                                            >
                                                <input
                                                    style={{ width: "100%" }}
                                                    onKeyPress={isNumber}
                                                    type="password"
                                                    pattern="[0-9]+"
                                                    maxLength="6"
                                                    minLength="6"
                                                    value={OTPValue}
                                                    onChange={updateInputValue}
                                                    placeholder="123456"
                                                    name=""
                                                    id="OTPValue"
                                                    className="k-textbox"
                                                ></input>
                                            </div>
                                        </div>
                                    </div>
                                    <br></br>
                                    <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                                        <div className="box">
                                            <div
                                                className="text-center"
                                                style={{ marginTop: "1rem" }}
                                            >
                                                {timeLeft === 0 ? (<Button
                                                    type={"submit"}
                                                    id="docSubmit"
                                                    key="docSubmit"
                                                    primary={true}
                                                    onClick={verifyOTPDetails}
                                                    style={{ padding: "6px" }}
                                                    className="btn btn-success btnMaybank "
                                                >
                                                    {"REQUEST"}
                                                </Button>) :

                                                    (<Button
                                                        className="btn btn-success btnMaybank"
                                                        style={{ padding: "6px" }}
                                                        primary={true}
                                                        onClick={verifyOTPDetails}
                                                        disabled={!OtpconfirmDisabled}
                                                    >
                                                        CONFIRM
                                                    </Button>)}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-1 col-md-1 col-lg-1">
                                        <div className="box"></div>
                                    </div>
                                </div>
                            </Notification>
                        </NotificationGroup>
                    ) : (
                        ""
                    )}
                </FormContainer>

            </div>
        </div>
    )
}

export default ReviewDetails;